<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="holidays"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.date="{ item }">
        {{ item.date | dateFormat }}
      </template>

      <template v-slot:item.regions="{ item }">
        <div v-if="item.regions.length < 4">
          <v-chip v-for="region in item.regions" :key="region.id" class="mr-1">
            {{ region.name }}
          </v-chip>
        </div>

        <v-tooltip v-else top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-chip
                v-for="region in item.regions.slice(0, 3)"
                :key="region.id"
                class="mr-1"
              >
                {{ region.name }}
              </v-chip>
              <span>... +{{ item.regions.length - 3 }} </span>
            </span>
          </template>
          <span style="max-width: 500px; float: left; word-wrap: break-word;">
            <v-chip
              v-for="region in item.regions"
              :key="region.id"
              class="ma-1"
            >
              {{ region.name }}
            </v-chip></span
          >
        </v-tooltip>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="show(item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { isEqual } from 'lodash';
import { dateFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'HolidaysList',

  filters: {
    dateFormat
  },

  props: {
    holidays: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      default: () => ({
        total: -1
      })
    },
    options: {
      type: Object,
      default: () => {}
    },
    page: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    sortBy: {
      type: [String, Array],
      default: 'id'
    },
    sortDesc: {
      type: [Boolean, Array],
      default: false
    },
    multiSort: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    listeners: function() {
      return Object.assign({}, this.$listeners, {
        'update:options': this.updateOptions
      });
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id',
          width: '70px'
        },
        {
          text: this.$t('ITEM.DATE'),
          value: 'date',
          width: '130px'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'title'
        },
        {
          text: this.$t('REGIONS.ITEMS'),
          value: 'regions',
          sortable: false
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center',
          sortable: false
        }
      ];
    }
  },

  methods: {
    updateOptions(options) {
      if (isEqual(options, this.options)) {
        return;
      }

      this.$emit('update:options', options);
    },
    show(item) {
      this.$emit('show', item);
    }
  }
};
</script>
